import { ProjectType } from 'core/domain/project/model/projectModel';
import { ProjectDeleteError400Type } from 'constants/projects';
import { MessageErrorModel } from 'hooks/useMessage';
import { translate } from './translation';

export const projectTypeTranslationManager: Record<ProjectType, string> = {
  [ProjectType.HOME]: translate('_PROJECT_TYPE_HOME'),
  [ProjectType.RENT]: translate('_PROJECT_TYPE_RENT'),
  [ProjectType.OFFICE]: translate('_PROJECT_TYPE_OFFICE'),
  [ProjectType.PARKING_SLOT]: translate('_PROJECT_TYPE_PARKING_SLOT'),
  [ProjectType.HOTEL]: translate('_PROJECT_TYPE_HOTEL'),
  [ProjectType.VACATIONAL_RENTAL]: translate('_PROJECT_TYPE_VACATIONAL_RENTAL'),
  [ProjectType.BUILDING]: translate('_PROJECT_TYPE_VACATIONAL_BUILDING'),
};

export const projectDeleteError400TranslationsManager = {
  [ProjectDeleteError400Type.HAS_ASSETS]: translate('_DELETE_PROJECT_ERROR_TEXT_HAS_ASSETS'),
  [ProjectDeleteError400Type.HAS_CAMERAS]: translate('_DELETE_PROJECT_ERROR_TEXT_HAS_CAMERAS'),
  [ProjectDeleteError400Type.HAS_COMMON_AREAS]: translate('_DELETE_PROJECT_ERROR_TEXT_HAS_COMMON_AREAS'),
  [ProjectDeleteError400Type.HAS_GATEWAYS]: translate('_DELETE_PROJECT_ERROR_TEXT_HAS_GATEWAYS'),
  [ProjectDeleteError400Type.HAS_INTERCOMS]: translate('_DELETE_PROJECT_ERROR_TEXT_HAS_INTERCOMS'),
  [ProjectDeleteError400Type.HAS_USERS_VERIFIERS]: translate('_DELETE_PROJECT_ERROR_TEXT_HAS_USERS_VERIFIERS'),
};

export const getDeleteProjectErrorText = (error: MessageErrorModel): string => {
  const defaultError = translate('_DELETE_PROJECT_MODAL_ERROR_MESSAGE');

  if (error.code !== 400) {
    return defaultError;
  }

  const textMessage = JSON.stringify(error.message) as ProjectDeleteError400Type;
  const error400Type = Object.values(ProjectDeleteError400Type).find((value) => textMessage.includes(value));

  return error400Type ? projectDeleteError400TranslationsManager[error400Type] : defaultError;
};
